function Social({ socialLink, image }) {
  return (
    <div className="social">
      <a href={image.additions ?? "" + socialLink}>{image.svg}</a>
    </div>
  );
}

export default Social;
